module.exports = __webpack_public_path__ + "img/user-group.4d7707f9.svg";